import { useMemo } from "react";
import { usePermissionContext } from "libs/context/PermissionContext";
import { createMenuConfig, filterMenuGroups } from "helpers/appSidebarMenu";

export function useFilteredAppMenuGroups() {
  const { permissionData } = usePermissionContext() || {};
  return useMemo(
    () => filterMenuGroups(createMenuConfig(permissionData)),
    [permissionData]
  );
}
